
const fontSizeScale = 1.2

export default {
  name: "RichText",
  props: {
    module: Object
  },
  computed: {
    content() {
      return this.resetContent(this.module?.data?.content)
    }
  },
  mounted() {
    this.adjustIframeSize()
    window.addEventListener("resize", this.adjustIframeSize)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustIframeSize)
  },
  methods: {
    resetContent(content) {
      const regex = /font-size:\s*(\d+)pt;/g
      return content
        .replace(regex, (match, fontSize) => {
          const newFontSize = Math.round(fontSize * fontSizeScale)
          return `font-size: ${newFontSize}pt;`
        })
        .replace(/font-family\s*:\s*[^;]*;?/g, "")
        .replace(/(face="[^"]*")/gi, "")
    },
    adjustIframeSize() {
      const iframes = this.$refs.contentRef.querySelectorAll(".note-video-clip")
      if (iframes) {
        iframes.forEach(iframe => {
          const width = iframe.getAttribute("width")
          const height = iframe.getAttribute("height")
          if (width !== "100%" && height !== "100%") {
            const widthValue = parseInt(width)
            const heightValue = parseInt(height)
            const containerWidth = this.$refs.contentRef.offsetWidth
            const aspectRatio = widthValue / heightValue
            const calculatedHeight = containerWidth / aspectRatio
            iframe.style.width = containerWidth + "px"
            iframe.style.height = calculatedHeight + "px"
          }
        })
      }
    }
  }
}
